export const INTERNAL_SLOT_NAME = '__root';
